import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAssinarAltExecutor = ({ dadosOs, sqAltExec, sgAtividade, formik }) => {
  const {
    request: assinarRequest,
    data: assinarData,
    errors: assinarErrors,
    isLoading: assinarIsLoading,
  } = useApiClient();

  const assinarAtividade = () => {
    const parametros = {
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialAlteracaoExecutor: sqAltExec,
      listaExecutoresOs: formik.values.listaExecutoresOs,
      textoJustificativa: formik.values.textoJustificativa,
      siglaAtividade: sgAtividade,
      nomeAtividade: "Diretor Lavra Termo de Alteração de Auditor para Ciência Pessoal - DTE", // Sigla Atividade 'A1'
      sequencialOrdemServico: dadosOs.sequencial,
    };

    assinarRequest(apiRoutes.fiscalizacao.ordemservico.assinarAltExec, parametros);
  };

  useEffect(() => {
    if (assinarIsLoading) return;

    if (!assinarData && !assinarErrors) return;

    if (assinarData) {
      toast.success("Documento da atividade assinado com sucesso.");
    }
  }, [assinarData, assinarErrors, assinarIsLoading]);

  return { assinarIsLoading, assinarAtividade, assinarErrors };
};

export default useAssinarAltExecutor;
